// constants/roles.js
export const ROLES = {
  SUPER_ADMIN: 'superAdmin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
  GUEST: 'guest'
};

// 角色权限映射
export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: ['*'], // 所有权限
  [ROLES.ADMIN]: [
    'dashboard',
    'user:read',
    'user:write',
    'settings',
    'reports',
    'index'
  ],
  [ROLES.MANAGER]: [
    'dashboard',
    'user:read',
    'reports'
  ],
  [ROLES.USER]: [
    'dashboard',
    'profile'
  ],
  [ROLES.GUEST]: [] // 无权限
};